import(/* webpackMode: "eager", webpackExports: ["AssistantLanding"] */ "/app/components/Assistant/AssistantLanding.tsx");
